import gql from 'graphql-tag';

export const updateVisitorWatchlistMutation = gql(/* GraphQL */ `
  mutation updateVisitorWatchlist($input: VisitorWatchlistUpdateInput!) {
    updateVisitorWatchlist(input: $input) {
      visitorWatchlist {
        id
        organizationId
        severityLevel
        notes
        reportedBy
        createdBy
        updatedBy
        createdAt
        updatedAt
        tenantIds
        visitorMatchingInfo {
          firstName {
            primaryValue
            alternateValues
            matchType
          }
          lastName {
            primaryValue
            alternateValues
            matchType
          }
          email {
            primaryValue
            alternateValues
            matchType
          }
          phone {
            primaryValue
            alternateValues
            matchType
          }
        }
      }
    }
  }
`);
